import { injectReducer } from '../../store/reducers';

export default store => ({
    /*  Async getComponent is only invoked when route matches   */
    path: 'notifications',

    getComponent(nextState, cb) {
        const Notifications = require('./containers/NotificationContainer').default;
        cb(null, Notifications);
    },
});



// WEBPACK FOOTER //
// src/routes/notification/index.js